import { render, staticRenderFns } from "./quick_links.vue?vue&type=template&id=65b0df55&"
import script from "./quick_links.vue?vue&type=script&lang=js&"
export * from "./quick_links.vue?vue&type=script&lang=js&"
import style0 from "./quick_links.vue?vue&type=style&index=0&id=65b0df55&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports